import request from '../utils/request';

// 获取用户列表
export const getUserList = (params) => {
  return request({
    url: '/api/vincent/users',
    method: 'GET',
    params
  });
};

// 获取用户详情
export const getUserDetail = (userId) => {
  return request({
    url: `/api/vincent/users/${userId}`,
    method: 'GET'
  });
};

// 封禁用户
export const banUser = (userId, data) => {
  return request({
    url: `/api/vincent/users/${userId}/ban`,
    method: 'PUT',
    data
  });
};

// 解封用户
export const unbanUser = (userId) => {
  return request({
    url: `/api/vincent/users/${userId}/unban`,
    method: 'PUT'
  });
};

// 删除用户
export const deleteUser = (userId) => {
  return request({
    url: `/api/vincent/users/${userId}`,
    method: 'DELETE'
  });
};
